import React,{useState,useEffect} from "react";
import api from "../../../api/api";
import { useForm } from "react-hook-form";
import axios from "axios";

const PermModelName = (item) => {
    return (
      <div className="flex items-center gap-1">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="1em"
          height="1em"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth={2}
            d="M20 12H4"
          />
        </svg>
        <svg
          id=""
          className="h-6 w-6 text-[#F8D775]"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          role="img"
          width="1em"
          height="1em"
          preserveAspectRatio="xMidYMid meet"
          viewBox="0 0 1024 1024"
        >
          <path
            fill="currentColor"
            d="M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12c0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z"
          />
        </svg>
        {/* <p className="text-red-500">Task Assigned Details</p> */}
        {/* {
                            (index-1) >=0 ? 
                            (item.model === perm[index-1].model ? '' : 
                            <p>{item.model}</p> )
                            :<p className="text-red-500">{item.model}</p>
                          } */}
        .<p className="text-red-500">{item.model}</p>
      </div>
    );
  };




const CreateGroup = () => {
const [perm, setPerm] = useState([]);
const [role, setRole] = useState([]);
const { register, handleSubmit, unregister } = useForm();

useEffect(() => {
  console.log(role)
}, [role])



useEffect(() => {
      api
        .get(`users/permissions/`)
        .then((response) => {
        //   console.log(response.data);
           setPerm(response.data)
        })
        .catch((err) => {
          console.log(err);
        });
  }, []);


const handleChange = (id) => {
    if (role.includes(id)) {
      let newArr = [...role];
      newArr.pop(id);
      setRole(newArr);
      return;
    }

    setRole((prev) => [...prev, id]);
  };

  const handleSub = (data) => {
    data.permissions = role

    api.post('users/groups/', data)
    .then(response=> {
        console.log(response.data)
    }).catch(error=> {
        console.log(error)
    })

}


  return (
    <form className="md:px-10 px-2" onSubmit={handleSubmit(handleSub)}>
      <h1 className="text-center text-primary-red text-3xl my-3 font-bold">Create Group</h1>
      <div className="mt-3 mb-3">
      <label className="text-primary-red ">Group Name</label>
      <input type="text" className="outline-none text-primary-blue px-3" placeholder="Enter group name" 
      {...register("name", {required:false})}
      />
      </div>
      {
      perm.length > 0 ? 
      perm.map((item, index) => {
        return (
          <div key={index}>
            {index - 1 >= 0
              ? item.model === perm[index - 1].model
                ? ""
                : PermModelName(item)
              : PermModelName(item)}

            <div className="flex items-center px-7">
              <svg
                className="h-5 w-5"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
                role="img"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 24 24"
              >
                <g
                  fill="#fff"
                  stroke="#EE1D23"
                  strokeLinejoin="round"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    d="M4 4v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8.342a2 2 0 0 0-.602-1.43l-4.44-4.342A2 2 0 0 0 13.56 2H6a2 2 0 0 0-2 2Zm5 9h6m-6 4h3"
                  />
                  <path d="M14 2v4a2 2 0 0 0 2 2h4" />
                </g>
              </svg>
              <div className="flex items-center gap-1">
                <h1>{item.name}</h1>
                <div className="form-check">
                  <input
                    className="form-check-input float-left my-1 h-4 w-4 cursor-pointer appearance-none rounded-full border border-blue-900 bg-yellow-300 bg-contain bg-center bg-no-repeat align-top transition duration-200 checked:border-blue-600 checked:bg-blue-600 focus:outline-none"
                    type="checkbox"
                    defaultValue=""
                    onChange={() => {
                      handleChange(item.id);
                    }}
                    id="flexCheckDefault3"
                  />
                </div>
              </div>
            </div>
          </div>
        );
      }) : "Loading......."
    
    }
      <input type="submit" value="Submit"
      className="ml-10 mt-10 border border-green-600 py-2 px-7 cursor-pointer text-primary-green hover:text-white hover:bg-green-500"
      />
    </form>
  );
};

export default CreateGroup;
